

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import _ from 'lodash'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { backofficeSharedDataService } from '@/components/Backoffice/Store/backoffice-shared-data-service'
import BackofficeOrcamentoStore from '@/components/Backoffice/Store/BackofficeOrcamentoStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { onlyFloat, onlyAlphaNumeric, onlyNumber, timeout, opcaoHabilitadoShared, campoHabilitadoShared, ApiRequestWithRetry, idadeGestacionalMax, limitarIdadeGestacionalCommon } from '@/utils/common'
import { Agendamento, Autorizacao } from '@/types/core'
import EventBus from '@/plugins/EventBus'
import { getTamanhoMaximoCarteirinha } from '@/utils/mascaraCarteirinha'
import { TipoUsuarioEnum, Procedimento, Equipamento, OpmeMaterial, GrupoOpmes } from '@/types/_'
import { StatusDoProtocoloEnum } from '@/types/interfaces/protocolo/status-do-protocolo.enum'
import { ModalManagerMixin } from '@/mixins/modal'
import { useMedicos } from '@/composables'
import BackofficeHonorarioMedico from './components/formulario/BackofficeHonorarioMedico.vue'
import BackofficeHonorarioAnestesista from './components/formulario/BackofficeHonorarioAnestesista.vue'
import BackofficeEquipeMedica from './components/formulario/BackofficeEquipeMedica.vue'
import BackofficeReservaHemocomponentes from './components/formulario/BackofficeReservaHemocomponentes.vue'

interface CampoExameIntraoperatorio {
  prop: string;
  label: string;
}

interface CampoAdicionalExameIntraoperatorio {
  prop: string;
  label: string;
  type: string;
  items?: { value: string | boolean; text: string }[];
  conditions: { prop: string; value: string | boolean }[];
}

@Component({
  components: {
    BackofficeHonorarioMedico,
    BackofficeHonorarioAnestesista,
    BackofficeEquipeMedica,
    BackofficeReservaHemocomponentes,
  },
})
export default class ModalAlterarSolicitacao extends Vue {
  @Prop({ required: true }) tipoUsuario: TipoUsuarioEnum

  backofficeSharedDataService = backofficeSharedDataService
  idadeGestacionalKey = 0
  readonly idadeGestacionalMax = idadeGestacionalMax

  agd: any = new Agendamento.Agendamento()
  aut: any = new Autorizacao.Autorizacao()
  modalManager = new ModalManagerMixin()

  readonly RESERVA_UTI_OPTIONS = [
    { value: 'Adulto', opcao: 'adulto', label: 'Adulto' },
    { value: 'ReservaUtiSim', opcao: 'reservaUtiSim', label: 'Sim' },
    { value: 'ReservaUtiNao', opcao: 'reservaUtiNao', label: 'Não' },
    { value: 'Cardio', opcao: 'cardio', label: 'Cardio' },
    { value: 'Cardiologia', opcao: 'cardiologia', label: 'Coronariana' },
    { value: 'Geral', opcao: 'geral', label: 'Geral' },
    { value: 'Neuro', opcao: 'neuro', label: 'Neuro' },
    { value: 'Pediatrica', opcao: 'pediatrica', label: 'Pediátrica' },
    { value: 'NeoNatal', opcao: 'neoNatal', label: 'Neonatal' },
    { value: 'SemiIntensiva', opcao: 'semiIntensiva', label: 'Semi instensiva' },
    { value: 'SemiIntensivaInfantil', opcao: 'semiIntensivaInfantil', label: 'Semi intensiva infantil' },
    { value: 'Neurologica', opcao: 'neurologica', label: 'Neurológica' },
    { value: 'SemReserva', opcao: 'semReservaUti', label: 'Sem reserva' },
  ]

  readonly TIPO_INTERNACAO_OPTIONS = [
    { value: 'Clinica', opcao: 'clinica', label: 'Clínica' },
    { value: 'Cirurgica', opcao: 'cirurgica', label: 'Cirúrgica' },
    { value: 'Obstetrica', opcao: 'obstetrica', label: 'Obstétrica' },
    { value: 'Pediatrica', opcao: 'pediatrica', label: 'Pediátrica' },
    { value: 'Psiquiatrica', opcao: 'psiquiatrica', label: 'Psiquiatríca' },
  ]

  readonly TIPO_PROCEDIMENTO_OPTIONS = [
    { value: 'Ambulatorial', opcao: 'ambulatorial', label: 'Ambulatorial' },
    { value: 'Internacao', opcao: 'internacao', label: 'Internação' },
    { value: 'HospitalDia', opcao: 'hospitalDia', label: 'Hospital Dia' },
  ]

  readonly CARATER_OPTIONS = [
    { value: 'EletivoAutorizacao', opcao: 'eletivo', label: 'Eletivo' },
    { value: 'Urgencia', opcao: 'urgencia', label: 'Urgência' },
    { value: 'EletivoSemAutorizacao', opcao: 'emergencia', label: 'Emergência' },
    { value: 'Emergencia', opcao: 'emergenciaEfetiva', label: 'Emergência' },
  ]

  readonly CLASSIFICACAO_CIRURGIA_OPTIONS = [
    { value: 'Limpa', opcao: 'limpa', label: 'Limpa' },
    { value: 'PotencialmenteContaminada', opcao: 'potencialmenteContaminada', label: 'Potencialmente contaminada' },
    { value: 'Contaminada', opcao: 'contaminada', label: 'Contaminada' },
    { value: 'Infectada', opcao: 'infectada', label: 'Infectada' },
  ]

  readonly ANESTESIA_HOSPITAL_OPTIONS = [
    { value: 'Sim', opcao: 'anestesiaSim', label: 'Sim' },
    { value: 'Nao', opcao: 'anestesiaNao', label: 'Não' },
    { value: 'NaoAplica', opcao: 'naoAplica', label: 'Não se aplica' },
  ]

  readonly TECNICA_CIRURGIA_OPTIONS = [
    { value: 'Robotica', opcao: 'robotica', label: 'Robotica' },
    { value: 'Video', opcao: 'video', label: 'Video' },
    { value: 'Convencional', opcao: 'convencional', label: 'Convencional' },
  ]

  readonly COMPLEXIDADE_OPTIONS = [
    { value: 'Baixa', opcao: 'baixa', label: 'Baixa' },
    { value: 'Media', opcao: 'media', label: 'Media' },
    { value: 'Alta', opcao: 'alta', label: 'Alta' },
  ]

  readonly viewModal = {
    confirmarFluxoAlteracaoOrcamento: 'modal-confirmar-fluxo-alteracao-orcamento',
  }

  // Esse objeto foi a partir do mapeamento dos campos booleanos no template
  // solicitacao-cirurgia.vue. Cada campo representa um exame: a propriedade
  // correspondente assume true quando o exame está selecionado e false caso contrário.
  // Os nomes das propriedades e labels foram extraídos diretamente do template.
  readonly CAMPOS_EXAMES_INTRAOPERATORIOS: CampoExameIntraoperatorio[] = [
    { prop: 'anatomiaPatologica', label: 'Anatomia patológica' },
    { prop: 'biopsia', label: 'Biópsia de congelação' },
    { prop: 'biobanco', label: 'Biobanco' },
    { prop: 'broncoscopiaFlexivel', label: 'Broncoscopia Flexível' },
    { prop: 'tomografiaParaEstereotaxia', label: 'Tomografia para estereotaxia' },
    { prop: 'ultrassonografiaDeImagem', label: 'Ultrassonografia de imagem' },
    { prop: 'ultrassonografiaLaparoscopio', label: 'Ultrassonografia laparoscópio' },
    { prop: 'radioterapia', label: 'Radioterapia' },
    { prop: 'ressonancia', label: 'Ressonância' },
    { prop: 'monitorizacaoNeurofisiologica', label: 'Monitorização Neurofisiológica' },
    { prop: 'ecotransesofagico', label: 'Ecotransesofagico' },
    { prop: 'rxScopia', label: 'Raio-x / Radioscopia' },
    { prop: 'dimen', label: 'DIMEN - Medicina Nuclear' },
    { prop: 'catho', label: 'Catho' },
    { prop: 'cellSaver', label: 'Cell Saver' },
    { prop: 'colangiografia', label: 'Colangiografia' },
    { prop: 'colangiopancreatografiaRetrograda', label: 'Colangiopancreatografia retrógrada' },
    { prop: 'escleraUnicamp', label: 'Esclera - UNICAMP' },
    { prop: 'endoscopia', label: 'Endoscopia' },
    { prop: 'neuronavegacao', label: 'Neuronavegação' },
    { prop: 'nervoNIM', label: 'Nervo NIM' },
    { prop: 'potencialEvocado', label: 'Potencial evocado' },
    { prop: 'pth', label: 'PTH' },
    { prop: 'tipagemSanguinea', label: 'Tipagem sanguínea' },
    { prop: 'tomografia', label: 'Tomografia' },
    { prop: 'ultrassonografiaIntraoperatoria', label: 'Ultrassonografia intra-operatória' },
    { prop: 'ultrassonografiaRadiologia', label: 'Ultrassonografia radiologia' },
    { prop: 'ultrassonografiaRadiologiaAcompanhamento', label: 'Ultrassonografia radiologia acompanhamento' },
    { prop: 'transporte', label: 'Transporte' },
    { prop: 'udo', label: 'UDO' },
    { prop: 'ecocardiograma', label: 'Ecocardiograma' },
    { prop: 'ecointraoperatorio', label: 'Ecointraoperatório' },
    { prop: 'examesLaboratoriais', label: 'Exames laboratoriais' },
    { prop: 'mamografia', label: 'Mamografia' },
    { prop: 'medicinaNuclear', label: 'Medicina nuclear' },
    { prop: 'culturaSonicacao', label: 'Cultura / Sonicação' },
    { prop: 'colonoscopia', label: 'Colonoscopia' },
    { prop: 'fivmed', label: 'Fivmed' },
    { prop: 'congelacaoIPC', label: 'Congelação IPC' },
    { prop: 'congelacaoMultipat', label: 'Congelação Multipat' },
    { prop: 'congelacaoBACCHI', label: 'Congelação BACCHI' },
    { prop: 'congelacaoFilomenaMarinhoCarvalho', label: 'Congelação Filomena Marinho Carvalho' },
    { prop: 'congelacaoPathos', label: 'Congelação Pathos' },
    { prop: 'congelacaoFerdinando', label: 'Congelação Ferdinando' },
    { prop: 'congelacaoSalomao', label: 'Congelação Salomão' },
    { prop: 'congelacaoLoccus', label: 'Congelação Loccus' },
    { prop: 'congelacaoFleury', label: 'Congelação Fleury' },
    { prop: 'congelacaoEinstein', label: 'Congelação Einstein' },
    { prop: 'congelacaoBML', label: 'Congelação BML' },
    { prop: 'congelacaoCIPAC', label: 'Congelação CIPAC' },
    { prop: 'congelacaoPathology', label: 'Congelação Pathology' },
    { prop: 'anestesiaAMD', label: 'Anestesia AMD' },
    { prop: 'exameEcoIntraoperatorio', label: 'Exame eco intraoperatório' },
    { prop: 'exameUsgIntraoperatorio', label: 'Exame USG intraoperatório' },
    { prop: 'gdlReservaDeUtiAdulto', label: 'GDL reserva de UTI adulto' },
    { prop: 'gdlReservaDeUtiPediatrica', label: 'GDL reserva de UTI pediátrica' },
    { prop: 'gdlUiHemoAngio', label: 'GDL UI Hemo Angio' },
    { prop: 'laboratorioPthRapido', label: 'Laboratório PTH Rápido' },
    { prop: 'laboratorioBacchi', label: 'Laboratório Bacchi' },
    { prop: 'laboratorioFilomenaMarinoCarvalho', label: 'Laboratório Filomena Marino Carvalho' },
    { prop: 'laboratorioPathosDiagnosticosMedicos', label: 'Laboratório Pathos Diagnósticos Médicos' },
    { prop: 'laboratorioLocus', label: 'Laboratório Locus' },
    { prop: 'laboratorioFleury', label: 'Laboratório Fleury' },
    { prop: 'servicoAnextesia', label: 'Serviço Anextesia' },
    { prop: 'anestesiaGaap', label: 'Anestesia GAAP' },
    { prop: 'broncoscopista', label: 'Broncoscopista' },
    { prop: 'exameMamografia', label: 'Exame mamografia' },
    { prop: 'exameRxIntraoperatorio', label: 'Exame RX Intraoperatório' },
    { prop: 'reservaDeRoll', label: 'Reserva de Roll' },
    { prop: 'laboratorioCongelacaoServicoInterno', label: 'Laboratório de congelação (serviço interno)' },
    { prop: 'laboratorioCongelacaoServicoExternoParticular', label: 'Laboratório de congelação (serviço externo - Particular)' },
    { prop: 'gdlRetaguardaUtiAdulto', label: 'GDL Retaguarda de UTI Adulto' },
    { prop: 'gdlRetaguardaUtiPediatrica', label: 'GDL Retaguarda de UTI Pediátrica' },
    { prop: 'laboratorioFleuryAnalisesClinicas', label: 'Laboratório Fleury (Análises Clínicas)' },
    { prop: 'exameEcoIntraoperatorioSemProfissional', label: 'Exame - Eco Intraoperatório Sem Profissional' },
    { prop: 'exameUltrassomIntraoperatorioComProfissional', label: 'Exame - Ultrassom Intraoperatório Com Profissional' },
    { prop: 'exameTomografiaIntraoperatorio', label: 'Exame - Tomografia Intraoperatório' },
    { prop: 'exameEndoscopiaIntraoperatoriaComProfissional', label: 'Exame - Endoscopia Intraoperatória Com Profissional' },
    { prop: 'exameEndoscopiaIntraoperatoriaSemProfissional', label: 'Exame - Endoscopia Intraoperatória Sem Profissional' },
    { prop: 'exameBroncoscopiaIntraoperatoriaComProfissional', label: 'Exame - Broncoscopia Intraoperatória Com Profissional' },
    { prop: 'exameBroncoscopiaIntraoperatoriaSemProfissional', label: 'Exame - Broncoscopia Intraoperatória Sem Profissional' },
    { prop: 'exameEcoIntraoperatorioComProfissional', label: 'Exame - Eco Intraoperatório Com Profissional' },
    { prop: 'outros', label: 'Outros' },
    { prop: 'semExameIntraoperatorio', label: 'Sem exame intra-operatório' },
  ];

  // Campos complementares que dependem diretamente de um exame principal.
  // São usados para registrar informações adicionais relacionadas a esse exame.
  //
  // Exemplo: o campo "ultrassonografiaIntraoperatoriaEquipeDoHospital" complementa
  // o campo "ultrassonografiaIntraoperatoria", indicando se há necessidade da equipe do hospital.
  readonly CAMPOS_ADICIONAIS_EXAMES_INTRAOPERATORIOS: Record<string, CampoAdicionalExameIntraoperatorio[]> = {
    anatomiaPatologica: [
      {
        prop: 'anatomiaPatologicaHospitalOuParticular',
        label: 'Origem do serviço',
        type: 'select',
        items: [
          { value: 'Hospital', text: 'Do próprio hospital' },
          { value: 'Particular', text: 'Particular (externo)' },
        ],
        conditions: [
          { prop: 'anatomiaPatologica', value: true },
        ],
      },
      {
        prop: 'anatomiaPatologicaParticularLocal',
        label: 'Local de prestação do serviço',
        type: 'text',
        conditions: [
          { prop: 'anatomiaPatologica', value: true },
          { prop: 'anatomiaPatologicaHospitalOuParticular', value: 'Particular' },
        ],
      },
    ],
    biopsia: [
      {
        prop: 'biopsiaHospitalOuParticular',
        label: 'Origem do serviço',
        type: 'select',
        items: [
          { value: 'Hospital', text: 'Do próprio hospital' },
          { value: 'Particular', text: 'Particular (externo)' },
        ],
        conditions: [
          { prop: 'biopsia', value: true },
        ],
      },
      {
        prop: 'biopsiaParticularLocal',
        label: 'Local de prestação do serviço',
        type: 'text',
        conditions: [
          { prop: 'biopsia', value: true },
          { prop: 'biopsiaHospitalOuParticular', value: 'Particular' },
        ],
      },
    ],
    ultrassonografiaIntraoperatoria: [
      {
        prop: 'ultrassonografiaIntraoperatoriaEquipeDoHospital',
        label: 'Precisa da equipe do hospital?',
        type: 'radio',
        items: [
          { value: true, text: 'Sim' },
          { value: false, text: 'Não' },
        ],
        conditions: [
          { prop: 'ultrassonografiaIntraoperatoria', value: true },
        ],
      },
    ],
    outros: [
      {
        prop: 'outrosEspecificar',
        label: 'Especificar',
        type: 'text',
        conditions: [
          { prop: 'outros', value: true },
        ],
      },
    ],
  }

  readonly CAMPOS_TIPOS_ANESTESIA = [
    { value: 'Bloqueio', opcao: 'bloqueio', label: 'Bloqueio' },
    { value: 'BloqueiosEspinhais', opcao: 'bloqueiosEspinhais', label: 'Bloqueios Espinhais' },
    { value: 'Geral', opcao: 'geral', label: 'Geral' },
    { value: 'GeralMaisPlexo', opcao: 'geralMaisPlexo', label: 'Geral + Plexo' },
    { value: 'Local', opcao: 'local', label: 'Local' },
    { value: 'LocalAssistida', opcao: 'localAssistida', label: 'Local Assistida' },
    { value: 'LocalComSedacao', opcao: 'localComSedacao', label: 'Local com Sedação' },
    { value: 'Peridural', opcao: 'peridural', label: 'Peridural' },
    { value: 'Plexo', opcao: 'plexo', label: 'Plexo' },
    { value: 'Plexular', opcao: 'plexular', label: 'Plexular' },
    { value: 'Raqui', opcao: 'raqui', label: 'Raqui' },
    { value: 'RaquiMaisSedacao', opcao: 'raquiMaisSedacao', label: 'Raqui + Sedação' },
    { value: 'RetroBulbar', opcao: 'retroBulbar', label: 'Retro-bulbar' },
    { value: 'Sedacao', opcao: 'sedacao', label: 'Sedação' },
    { value: 'SedacaoMaisPlexo', opcao: 'sedacaoMaisPlexo', label: 'Sedação + Plexo' },
    { value: 'Topica', opcao: 'topica', label: 'Tópica' },
    { value: 'Outros', opcao: 'outros', label: 'Outros' },
  ] as const

  get examesIntraoperatorios() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.examesIntraOperatorios || {}
  }

  get tipoInternacaoOptions() {
    return this.TIPO_INTERNACAO_OPTIONS.filter(opcao => this.opcaoHabilitado('tipoInternacao', opcao.opcao))
  }

  get tipoProcedimentoOptions() {
    return this.TIPO_PROCEDIMENTO_OPTIONS.filter(opcao => this.opcaoHabilitado('tipoProcedimento', opcao.opcao))
  }

  get caraterOptions() {
    return this.CARATER_OPTIONS.filter(opcao => this.opcaoHabilitado('carater', opcao.opcao))
  }

  get classificacaoCirurgiaOptions() {
    return this.CLASSIFICACAO_CIRURGIA_OPTIONS.filter(opcao => this.opcaoHabilitado('classificacaoCirurgia', opcao.opcao))
  }

  get anestesiaHospitalOptions() {
    return this.ANESTESIA_HOSPITAL_OPTIONS.filter(opcao => this.opcaoHabilitado('anestesiaHospital', opcao.opcao))
  }

  get tecnicaCirurgiaOptions() {
    return this.TECNICA_CIRURGIA_OPTIONS.filter(opcao => this.opcaoHabilitado('tecnicaDaCirurgia', opcao.opcao))
  }

  get complexidadeOptions() {
    return this.COMPLEXIDADE_OPTIONS.filter(opcao => this.opcaoHabilitado('complexidade', opcao.opcao))
  }

  get reservaUtiOptions() {
    return this.RESERVA_UTI_OPTIONS.filter(opcao => this.opcaoHabilitado('reservaUti', opcao.opcao))
  }

  get camposExamesIntraoperatorios() {
    const { campos } = this.getBackofficeGlobalStore.currentTemplate.formulario.examesIntraOperatorios
    const camposHabilitados = this.CAMPOS_EXAMES_INTRAOPERATORIOS.filter(campoExameIntraoperatorio => campos[campoExameIntraoperatorio.prop])
    return camposHabilitados
  }

  get camposAdicionaisExamesIntraoperatorios() {
    const result = Object.assign({}, this.CAMPOS_ADICIONAIS_EXAMES_INTRAOPERATORIOS)
    const { campos } = this.getBackofficeGlobalStore.currentTemplate.formulario.examesIntraOperatorios

    Object.entries(result).forEach(([parentProp, camposAdicionais]) => {
      const camposHabilitados = camposAdicionais.filter((campoAdicional) => {
        const possuiCampoAdicionalAtivo = campos[campoAdicional.prop]
        const atendeCondicoes = campoAdicional.conditions.every(c => this.examesIntraoperatorios[c.prop] === c.value)

        return possuiCampoAdicionalAtivo && atendeCondicoes
      })

      result[parentProp] = camposHabilitados
    })

    return result
  }

  handleExamesIntraoperatoriosItemChange(prop: string, checked: boolean) {
    // Remove todas as outras propriedades definidas quando a opção
    // 'semExameIntraoperatorio' é marcada.
    if (prop === 'semExameIntraoperatorio' && checked) {
      Object.keys(this.getBackofficeGlobalStore.solicitacaoAlterada.examesIntraOperatorios).forEach((key) => {
        this.getBackofficeGlobalStore.solicitacaoAlterada.examesIntraOperatorios[key] = undefined
      })
      this.getBackofficeGlobalStore.solicitacaoAlterada.examesIntraOperatorios.semExameIntraoperatorio = true
    }
  }

  $refs!: {
    solicitacaoAlteradaForm: any,
    opmeForm: any,
    reservaUTI: any,
    honorarioMedico: any,
    honorarioAnestesista: any,
    equipeMedica: any,
    hemocomponentes: any,
  }

  // Forçar reatividade
  private anestesiaReactivityKey = 0

  solicitacaoAlteradaForm: any = {
    valid: true,
    hospitalId: [(v: any) => !!v || 'Campo obrigatório.'],
    convenioId: [(v: any) => !!v || 'Campo obrigatório.'],
    planoId: [(v: any) => this.validatePlano(v)],
    categoriaId: [(v: any) => !!v || 'Campo obrigatório.'],
    carteirinha: [(v: any) => this.validateCarteirinha(v)],
    diariaProcedimentoInternacao: [(v: any) => this.validateProcedureEligibilityData(v)],
    carater: [(v: any) => !!v || 'Campo obrigatório.'],
    instrumentadorExternoEspecificar: [],
    tipoProcedimento: [],
    diaria: [],
    diariaUti: [],
    reservaUTI: [],
    comorbidade: [],
    medicacaoDapt: [],
    funcaoRenal: [],
    complexidade: [],
    classificacaoPacienteOncologico: [],
    hospitalAnesthetist: [(v: any) => this.validateHospitalAnesthetist(v)],
    otherAnesthetist: [(v: any) => this.validateOtherAnesthetist(v)],
    alergiaLatex: [],
    outrosTipoAnestesia: [(v: any) => this.validateOutrosTipoAnestesia(v)],
    medicamentosEspeciaisEspecificar: [],
    tecnicaDaCirurgia: [],
    tipoAnestesia: [(v: any) => this.validateTiposAnestesia(v)],
    idadeGestacional: [],
    gemelar: [],
  }

  debouncedFetchSurgerySolicitationEligibilityInfo = _.debounce(this.fetchSurgerySolicitationEligibilityInfo, 2000)

  procedureEligibilityData: {
    id: string,
    description: string,
  }[] = []

  loadingHealthInsuranceCardId: boolean = false
  disableSaveButton: boolean = false

  get anestesistasOptions() {
    return this.getBackofficeGlobalStore.clinicasDeAnestesia.data
  }

  get outroAnestesista() { return this.getBackofficeGlobalStore.outroAnestesista }
  set outroAnestesista(value: string) { this.getBackofficeGlobalStore.setOutroAnestesista(value) }

  validateExamesIntraoperatorios(): [true] | [false, string] {
    if (this.examesIntraoperatorios.semExameIntraoperatorio || !this.formulario.examesIntraOperatorios.obrigatorio) {
      return [true]
    }

    const camposValidos = Object.entries(this.examesIntraoperatorios)
      .filter(([prop, value]) => value)

    if (camposValidos.length === 0) {
      return [false, 'Preencha os exames intraoperatórios ou marque a opção "sem exame intraoperatório".']
    }

    return [true]
  }

  validateHospitalAnesthetist(inputValue: any) {
    if (this.opcaoHabilitado('alterarSolicitacao', 'naoEditarAnestesista') || (!this.opcaoHabilitado('alterarSolicitacao', 'naoEditarAnestesista') && !this.campoObrigatorio('anestesiaHospital'))) return true
    if (this.listaDeAnestesistasHabilitado
    && !this.opcaoHabilitado('anestesiaHospital', 'sempreSelecionarAnestesistaNaLista')
    && ((inputValue === 'Nao' && this.opcaoHabilitado('anestesiaHospital', 'selecaoOpcionalCasoNao')) || (inputValue === 'Sim' && this.opcaoHabilitado('anestesiaHospital', 'selecaoOpcionalCasoSim')))) return true
    if (this.listaDeAnestesistasHabilitado
    && ((inputValue === 'Nao' || (inputValue === 'Sim' && this.opcaoHabilitado('anestesiaHospital', 'sempreSelecionarAnestesistaNaLista'))) && !this.hospitalAnesthetist.id)) return 'Selecione um anestesista.'
    return !!inputValue || 'Campo obrigatório.'
  }

  validateOtherAnesthetist(inputValue: any) {
    if (this.opcaoHabilitado('alterarSolicitacao', 'naoEditarAnestesista') || (!this.opcaoHabilitado('alterarSolicitacao', 'naoEditarAnestesista') && !this.campoObrigatorio('anestesiaHospital'))) return true
    return !!inputValue || 'Campo obrigatório.'
  }

  validateProcedimentoPrincipalErrorMessage() {
    const isCampoObrigatorio = this.campoObrigatorio('procedimentoPrincipal')
    const isCampoDesabilitado = this.opcaoHabilitado('alterarSolicitacao', 'naoEditarProcedimentoPrincipal')
    const { procedimento } = this.getBackofficeGlobalStore.solicitacaoAlterada

    if (isCampoObrigatorio && !isCampoDesabilitado && !procedimento) {
      this.getErrorMessage.errorProcedimento = 'Campo obrigatório.'
      return false
    }

    return true
  }

  validateCarteirinha(v: any) {
    if (!!this.formulario && !!this.formulario.carteirinha && !!this.formulario.carteirinha.obrigatorio) {
      return !!v || 'Campo obrigatório.'
    }
    return true
  }

  validateProcedureEligibilityData(v: any) {
    if (!!this.formulario
      && !!this.formulario.diariaProcedimentoInternacao
      && this.formulario.diariaProcedimentoInternacao.habilitado
      && !!this.formulario.diariaProcedimentoInternacao.obrigatorio) {
      return !!v || 'Campo obrigatório.'
    }

    return true
  }

  validatePlano(v: any) {
    if (!!this.formulario && !!this.formulario.plano && !!this.formulario.plano.obrigatorio) {
      return !!v || 'Campo obrigatório.'
    }
    return true
  }

  validateOutrosTipoAnestesia(value: any) {
    if (this.getTipoAnestesia.includes('Outros') && !this.getOutrosTipoAnestesia) {
      return 'Campo obrigatório.'
    }
    return true
  }

  validateTiposAnestesia(value: any) {
    if (!this.formulario.tipoAnestesia || !this.formulario.tipoAnestesia.obrigatorio || value.length) {
      return true
    }
    return 'Campo obrigatório.'
  }

  lateralidades: any[] = [
    { key: 'Esquerdo', display: 'Esquerdo' },
    { key: 'Direito', display: 'Direito' },
    { key: 'Bilateral', display: 'Bilateral' },
    { key: 'NaoAplica', display: 'Não se aplica' },
  ]

  errorMessage: any = {
    errorProcedimento: '',
  }

  loadCancelar: boolean = false
  loadFechar: boolean = false
  loadAlterar: boolean = false
  loadHospital: boolean = false
  loadConvenio: boolean = false
  loadPlano: boolean = false
  loadCategoria: boolean = false
  loadProcedimentoPrincipal: boolean = false
  loadProcedimentosAssociados: boolean = false
  loadOpme: boolean = false
  loadingEquipamento = false
  loadAtualizarLateralidade: string = ''
  loadRemoveProcedimentosAssociados: string = ''
  loadRemoveGrupoOpme: string = ''
  loadRemoveOpmeGrupoOpme: string = ''

  loadEditarFornecedores: string = ''

  lastSelectedEquipmentsBeforeHospitalChange: string[] = []

  opmeRules = {
    id: [(v: any) => !!v || 'Campo obrigatório'],
    quantidade: [(v: any) => !!v || 'Campo obrigatório'],
    fornecedor1: [(v: any) => !!v || 'Campo obrigatório'],
    fornecedor2: [],
    fornecedor3: [],
    medidaTamanho: [(v: any) => this.getOPMEMeasureFieldRules(v)],
  }

  hospitalDiaMessage: string = 'Todos os procedimentos indicados são autorizados apenas em regime de <strong>Hospital Dia</strong> para a operadora selecionada. Faremos as seguintes tratativas:'

  hospitalAnesthetist = {
    id: '',
    nome: '',
    crm: '',
    temVinculoHospital: null,
  }

  getOPMEMeasureFieldRules(value) {
    if (this.getBackofficeGlobalStore.currentTemplate.formulario.opmes.medidaTamanho && this.getBackofficeGlobalStore.currentTemplate.formulario.opmes.medidaTamanho.obrigatorio) {
      return !!value || 'Campo obrigatório.'
    }
    return true
  }

  get loadingEditarFornecedores() {
    return this.loadEditarFornecedores
  }

  set loadingEditarFornecedores(value: string) {
    this.loadEditarFornecedores = value
  }

  get formulario() {
    return this.getBackofficeGlobalStore.currentTemplate.formulario
  }

  get fornecedorLabel() {
    return this.formulario && this.formulario.opmes && this.formulario.opmes.fornecedorLabel
      ? this.formulario.opmes.fornecedorLabel
      : 'fornecedor / marca'
  }

  get loadingHospital() {
    return this.loadHospital
  }

  set loadingHospital(value: boolean) {
    this.loadHospital = value
  }

  get loadingConvenio() {
    return this.loadConvenio
  }

  set loadingConvenio(value: boolean) {
    this.loadConvenio = value
  }

  get loadingPlano() {
    return this.loadPlano
  }

  set loadingPlano(value: boolean) {
    this.loadPlano = value
  }

  get loadingCategoria() {
    return this.loadCategoria
  }

  set loadingCategoria(value: boolean) {
    this.loadCategoria = value
  }

  get loadingCancelar() {
    return this.loadCancelar
  }

  set loadingCancelar(value: boolean) {
    this.loadCancelar = value
  }

  get loadingFechar() {
    return this.loadFechar
  }

  set loadingFechar(value: boolean) {
    this.loadFechar = value
  }

  get loadingAlterar() {
    return this.loadAlterar
  }

  set loadingAlterar(value: boolean) {
    this.loadAlterar = value
  }

  get loadingRemoveProcedimentosAssociados() {
    return this.loadRemoveProcedimentosAssociados
  }

  set loadingRemoveProcedimentosAssociados(value: string) {
    this.loadRemoveProcedimentosAssociados = value
  }

  get loadingRemoveGrupoOpme() {
    return this.loadRemoveGrupoOpme
  }

  set loadingRemoveGrupoOpme(value: string) {
    this.loadRemoveGrupoOpme = value
  }

  get loadingRemoveOpmeGrupoOpme() {
    return this.loadRemoveOpmeGrupoOpme
  }

  set loadingRemoveOpmeGrupoOpme(value: string) {
    this.loadRemoveOpmeGrupoOpme = value
  }

  get getBackofficeOrcamentoStore() {
    return getModule(BackofficeOrcamentoStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get showModalAnestesistas() {
    return this.getBackofficeGlobalStore.modal.listaDeAnestesistas
  }

  get showModalAlterarSolicitacao() {
    return this.getBackofficeGlobalStore.modal.alterarSolicitacao
  }

  set showModalAlterarSolicitacao(value: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'alterarSolicitacao', value })
  }

  get hospitais() {
    return this.getBackofficeGlobalStore.hospitais
  }

  get convenios() {
    return this.getBackofficeGlobalStore.convenios
  }

  get planos() {
    return this.getBackofficeGlobalStore.planos
  }

  get categorias() {
    return this.getBackofficeGlobalStore.categorias
  }

  get loadingAtualizarLateralidade() {
    return this.loadAtualizarLateralidade
  }

  set loadingAtualizarLateralidade(value: string) {
    this.loadAtualizarLateralidade = value
  }

  get loadingProcedimentoPrincipal() {
    return this.loadProcedimentoPrincipal
  }

  set loadingProcedimentoPrincipal(value: boolean) {
    this.loadProcedimentoPrincipal = value
  }

  get loadingProcedimentosAssociados() {
    return this.loadProcedimentosAssociados
  }

  set loadingProcedimentosAssociados(value: boolean) {
    this.loadProcedimentosAssociados = value
  }

  get loadingOpme() {
    return this.loadOpme
  }

  set loadingOpme(value: boolean) {
    this.loadOpme = value
  }

  get getErrorMessage() {
    return this.errorMessage
  }

  set getErrorMessage(value: any) {
    this.errorMessage = value
  }

  get getProcedimentoAssociados() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.procedimentosAssociados
  }

  get grupoOpmeDaSolicitacao() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.grupoOpmeDaSolicitacao
  }

  get categoriaCoberturaVigente() {
    if (this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.categoriaCoberturaVigente !== undefined) {
      return this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.categoriaCoberturaVigente
    }
    return true
  }

  get listaDeAnestesistasHabilitado() {
    // Usar propriedade de reatividade para forçar recálculo
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.anestesiaReactivityKey

    const store = this.getBackofficeGlobalStore
    if (!store || !store.template || !store.solicitacaoAlterada) {
      return false
    }

    const anestesiaDoHospital = store.solicitacaoAlterada.anestesiaDoHospital || ''

    const anestesistaListaHabilitado = this.opcaoHabilitado('anestesiaHospital', 'anestesistaLista')
    if (!anestesistaListaHabilitado) {
      return false
    }

    if (anestesiaDoHospital === 'Nao') {
      return true
    }

    if (anestesiaDoHospital === 'Sim') {
      const sempreSelecionarAnestesista = this.opcaoHabilitado('anestesiaHospital', 'sempreSelecionarAnestesistaNaLista')
      const selecaoOpcionalCasoSim = this.opcaoHabilitado('anestesiaHospital', 'selecaoOpcionalCasoSim')
      return sempreSelecionarAnestesista || selecaoOpcionalCasoSim
    }

    return false
  }

  get anestesistaNomeCrmHabilitado() {
    return this.campoHabilitado('anestesiaHospital') && this.getBackofficeGlobalStore.solicitacaoAlterada.anestesiaDoHospital === 'Nao' && !this.opcaoHabilitado('anestesiaHospital', 'anestesistaLista')
  }

  campoObrigatorioLabel(label: string, campo: string) {
    if (this.campoObrigatorio(campo)) return `${label} *`
    return label
  }

  campoObrigatorio(campo: string) {
    const formulario = this.getBackofficeGlobalStore.currentTemplate
    if (formulario.formulario
      && formulario.formulario[campo]
      && (formulario.formulario[campo].obrigatorio
        || formulario.formulario[campo].obrigatorioParaTodosOsConvenios
        || formulario.formulario[campo].obrigatorioParaConvenioParticular)
    ) {
      return true
    }
    return false
  }

  campoDisponivelNaEtapa(etapas: string[]): boolean {
    if (!this.getBackofficeGlobalStore.solicitacaoAlterada.etapa) return false

    const etapaAtual = this.getBackofficeGlobalStore.solicitacaoAlterada.etapa.key
    return etapas.includes(etapaAtual)
  }

  pasteAlphaNumeric(event: ClipboardEvent) {
    event.preventDefault()
    const alphaNumericPattern = /[^ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-]+/ig
    // @ts-ignore
    const stringPattern = (event.clipboardData || window.clipboardData).getData('text')
    const tamanhoMaximo = getTamanhoMaximoCarteirinha(this.mascaraCarteirinhaDoConvenio, this.formulario.carteirinha.tamanhoMaximoDeCaracteres)
    this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.carteirinha = stringPattern.replace(alphaNumericPattern, '').substring(0, tamanhoMaximo)
  }

  get mascaraCarteirinhaDoConvenio(): string {
    const convenio = this.patientHealthInsuranceData

    return (convenio && convenio.mascaraCarteirinha) || ''
  }

  get showPrivateOPMEField() {
    return this.formulario.opmes
      && this.formulario.opmes.campos
      && this.formulario.opmes.campos.opcaoParticular
  }

  async checkCategoriaCoberturaVigente(categoriaId: string) {
    const { hospital } = this.getBackofficeGlobalStore.solicitacaoAlterada
    // @ts-ignore
    if (!hospital.hospitalFazConsultaCoberturaVigente || hospital.tipoDeCoberturaVigente !== 'Categoria') return
    this.loadingCategoria = true
    const request = await this.getBackofficeGlobalStore.consultaCoberturaVigente(categoriaId)
    if (request.success) this.getBackofficeGlobalStore.setCategoriaCoberturaVigente(request.data.temCoberturaVigente)
    this.loadingCategoria = false
  }

  setAnesthetist() {
    if (this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista) {
      this.hospitalAnesthetist = {
        nome: this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.nome,
        crm: this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.crm,
        temVinculoHospital: this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.temVinculoHospital,
        id: this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.id,
      }
    }
  }

  @Watch('showModalAnestesistas')
  onAnesthetistChange(anesthetist) {
    if (!anesthetist) {
      this.setAnesthetist()
      this.$refs.solicitacaoAlteradaForm.validate()
    }
  }

  hospitalAnesthetistChange() {
    this.hospitalAnesthetist = {
      id: '',
      nome: '',
      crm: '',
      temVinculoHospital: null,
    }
    this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
      field: 'nomeAnestesista',
      value: '',
    })
    this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
      field: 'anestesistaCrm',
      value: '',
    })
    this.anestesiaReactivityKey = this.anestesiaReactivityKey + 1
  }

  changeAnesthetist() {
    this.getBackofficeGlobalStore.setModal({ name: 'listaDeAnestesistas', value: true })
  }

  modalOpmeChange() {
    this.$forceUpdate()
  }

  onlyNumberUtil(e: KeyboardEvent) {
    return onlyNumber(e)
  }

  onlyAlphaNumericUtil(e: KeyboardEvent) {
    return onlyAlphaNumeric(e)
  }

  onlyFloatUtil(value: number) {
    return onlyFloat(value)
  }

  materialChange(data: OpmeMaterial, index: number) {
    this.getBackofficeGlobalStore.materialChange({ opme: data, index })
  }

  adicionarOpme() {
    this.getBackofficeGlobalStore.adicionarOpme()
    this.$forceUpdate()
  }

  deleteOpme(index: number) {
    this.getBackofficeGlobalStore.deleteOpme(index)
    this.$forceUpdate()
  }

  gradeCompletaChange(data: GrupoOpmes) {
    // eslint-disable-next-line
    data.observacao = ''
    this.$forceUpdate()
  }

  showModalCadastrarMaterial() {
    this.getBackofficeGlobalStore.setShowModalCadastrarMaterial(true)
  }

  showModalCadastrarFornecedor() {
    this.getBackofficeGlobalStore.setShowModalCadastrarFornecedor(true)
  }

  async removeProcedimentosAssociado(procedimentoId: string) {
    this.loadingRemoveProcedimentosAssociados = procedimentoId
    await this.getBackofficeGlobalStore.removeProcedimentosAssociadoBackoffice(procedimentoId)
    this.loadingRemoveProcedimentosAssociados = ''
  }

  async deleteOpmeFromGrupoOpme(grupoOpmeId: string, opmeId: string) {
    this.loadingRemoveOpmeGrupoOpme = `${grupoOpmeId}${opmeId}`
    await this.getBackofficeGlobalStore.removerOpmeDoGrupo({ grupoOpmeId, opmeId })
    this.loadingRemoveOpmeGrupoOpme = ''
  }

  async inserirLateralidade(procedimentoId: string, event) {
    this.loadingAtualizarLateralidade = procedimentoId
    const request = await this.getBackofficeGlobalStore.updateProcedimentoBySolicitacaoId({ procedimentoId, lateralidade: event })
    if (!request.success) EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Houve um problema ao atualizar a lateralidade', icon: 'warning', color: '#C62828' })
    this.loadingAtualizarLateralidade = ''
  }

  async showModalProcedimentoPrincipal() {
    this.loadingProcedimentoPrincipal = true
    const request = await this.getBackofficeGlobalStore.getProcedimentosBackofficeSearch('')

    if (request.success) {
      this.getBackofficeGlobalStore.setModal({ name: 'editarProcedimentoPrincipal', value: true })
      this.getErrorMessage.errorProcedimento = ''
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingProcedimentoPrincipal = false
  }

  async showModalProcedimentosAssociados() {
    this.loadingProcedimentosAssociados = true
    const request = await this.getBackofficeGlobalStore.getProcedimentosBackofficeSearch('')

    if (request.success) {
      this.getBackofficeGlobalStore.setModal({ name: 'editarProcedimentosAssociados', value: true })
      this.getErrorMessage.errorProcedimento = ''
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingProcedimentosAssociados = false
  }

  async showModalOpme() {
    this.loadingOpme = true
    if (this.getBackofficeGlobalStore.procedimentoPrincipal && this.getBackofficeGlobalStore.procedimentoPrincipal.id !== '' && !!this.getBackofficeGlobalStore.procedimentosAssociados) {
      const { procedimentoPrincipal, procedimentosAssociados } = this.getBackofficeGlobalStore
      const codigoProcedimentos: any[] = []
      if (procedimentosAssociados.length > 0) {
        procedimentosAssociados.forEach((e: Procedimento) => codigoProcedimentos.push(e.codigo))
      }
      codigoProcedimentos.unshift(procedimentoPrincipal.codigo)
      await this.getBackofficeGlobalStore.getGrupoOpmeByMedico(codigoProcedimentos)
      this.getBackofficeGlobalStore.setModal({ name: 'editarOpme', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Procedimento principal não foi selecionado.', icon: 'warning', color: '#C62828' })
    }
    this.loadingOpme = false
  }

  campoHabilitado(prop: string) {
    return campoHabilitadoShared(this.getBackofficeGlobalStore.template, prop)
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    return opcaoHabilitadoShared(this.getBackofficeGlobalStore.template, prop1, prop2)
  }

  habilitaCamposGestacionais() {
    const procedimentoPrincipalHabilitaCamposGestacionais = !!(this.getBackofficeGlobalStore.solicitacaoAlterada.procedimento && this.getBackofficeGlobalStore.solicitacaoAlterada.procedimento.habilitaCamposGestacionais)
    const existeProcedimentoAssociadoComCamposGestacionaisHabilitados = !!(
      this.getProcedimentoAssociados
      && this.getProcedimentoAssociados.some(procedimentoAssociado => !!procedimentoAssociado.habilitaCamposGestacionais)
    )

    if (procedimentoPrincipalHabilitaCamposGestacionais || existeProcedimentoAssociadoComCamposGestacionaisHabilitados) {
      return true
    }
    this.getBackofficeGlobalStore.solicitacaoAlterada.dadosGestacionais = { idadeGestacional: null, gemelar: null }
    return false
  }

  limitarIdadeGestacional(value: number) {
    limitarIdadeGestacionalCommon(value, (max) => {
      this.getBackofficeGlobalStore.solicitacaoAlterada.dadosGestacionais.idadeGestacional = max
      this.idadeGestacionalKey += 1
    })
  }

  get template() {
    return this.getBackofficeGlobalStore.template
  }

  get hospital() {
    return this.getBackofficeGlobalStore.hospitais.find((hosp: any) => hosp.id === this.getBackofficeGlobalStore.solicitacaoAlterada.hospitalId)!
  }

  async hospitalChange(hospitalId: string) {
    this.loadingConvenio = true
    this.getBackofficeGlobalStore.clearConvenios()
    this.getBackofficeGlobalStore.clearPlanos()
    this.getBackofficeGlobalStore.clearCategorias()
    this.$refs.solicitacaoAlteradaForm.resetValidation()

    this.lastSelectedEquipmentsBeforeHospitalChange = this.getBackofficeGlobalStore.solicitacaoAlterada.equipamentos
      .map((elem: Equipamento) => elem.nome)
    this.getBackofficeGlobalStore.clearSolicitacaoAlteradaEquipamentos()

    await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)
    await this.getBackofficeGlobalStore.getAllConvenios(hospitalId)
    this.loadingConvenio = false
  }

  async fetchSurgerySolicitationEligibilityInfo() {
    try {
      this.loadingHealthInsuranceCardId = true

      const eligibilityApiResponse = await ApiRequestWithRetry(
        () => this.getSolicitacaoCirurgiaStore.getSurgerySolicitationEligibilityInfo({
          surgerySolicitationId: this.getBackofficeGlobalStore.solicitacaoAlterada.id,
          healthInsuranceCardId: this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.carteirinha,
          healthInsuranceId: this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.convenioId,
          procedureType: this.getBackofficeGlobalStore.solicitacaoAlterada.tipoProcedimento,
        }),
        1,
        0,
      )

      if (eligibilityApiResponse.success) {
        this.procedureEligibilityData = eligibilityApiResponse.data.procedimentoInternacao.map(item => ({
          id: item.id,
          description: `${item.tipo} - ${item.codigo} - ${item.descricao}`,
        }))

        if (this.procedureEligibilityData.length === 1) {
          this.getBackofficeGlobalStore.solicitacaoAlterada.solicitacaoProcedimentoInternacao = {
            procedimentoInternacaoId: this.procedureEligibilityData[0].id,
          }
        } else if (!this.procedureEligibilityData || this.procedureEligibilityData.length === 0) {
          this.getBackofficeGlobalStore.solicitacaoAlterada.solicitacaoProcedimentoInternacao = {
            procedimentoInternacaoId: '',
          }
        }
      } else {
        this.getBackofficeGlobalStore.solicitacaoAlterada.solicitacaoProcedimentoInternacao = {
          procedimentoInternacaoId: '',
        }
      }
    } finally {
      this.disableSaveButton = false
      this.loadingHealthInsuranceCardId = false
    }
  }

  async handleSurgerySolicitationEligibilityInfoFetch() {
    if (
      this.getBackofficeGlobalStore.solicitacaoAlterada.id
      && this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.carteirinha
      && this.getBackofficeGlobalStore.solicitacaoAlterada.tipoProcedimento
      && this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.convenioId
      && (
        this.patientHealthInsuranceData
        && this.patientHealthInsuranceData.autorizadorTipo
        && this.patientHealthInsuranceData.autorizadorTipo === 'SisAmil'
      )
    ) {
      this.disableSaveButton = true
      await this.debouncedFetchSurgerySolicitationEligibilityInfo()
    }
  }

  get patientHealthInsuranceData() {
    return this.getBackofficeGlobalStore.convenios.find(healthInsurance => healthInsurance.id === this.getBackofficeGlobalStore.solicitacaoAlterada.paciente.convenioId)
  }

  healthInsuranceCardIdChange() {
    this.handleSurgerySolicitationEligibilityInfoFetch()
  }

  async healthInsuranceCardIdPaste(event: ClipboardEvent) {
    this.pasteAlphaNumeric(event)

    await this.handleSurgerySolicitationEligibilityInfoFetch()
  }

  clearProcedimentosAoTrocarConvenio(hospital: any) {
    if (!hospital || !hospital.hospitalLimpaProcedimentosAoTrocarConvenio) return

    const podeLimparPrincipal = this.canEditProcedimentoPrincipal()
      && !this.opcaoHabilitado('alterarSolicitacao', 'naoEditarProcedimentoPrincipal')

    if (!podeLimparPrincipal) return

    this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
      field: 'procedimento',
      value: null,
    })

    const podeLimparAssociados = this.canAddOrDeleteProcedimentoAssociado()
      && !this.opcaoHabilitado('alterarSolicitacao', 'naoEditarProcedimentosAssociados')

    if (podeLimparAssociados) {
      this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
        field: 'procedimentosAssociados',
        value: [],
      })
    }
  }

  async convenioChange() {
    const { formulario } = this
    this.loadingPlano = true
    this.loadingCategoria = true
    this.getBackofficeGlobalStore.clearPlanos()
    this.$refs.solicitacaoAlteradaForm.resetValidation()

    const { hospital, hospitalId, paciente } = this.getBackofficeGlobalStore.solicitacaoAlterada

    this.clearProcedimentosAoTrocarConvenio(hospital)

    const response = await this.getBackofficeGlobalStore.getAllPlanos({ hospitalId, convenioId: paciente.convenioId })
    if (response.success) {
      this.solicitacaoAlteradaForm.planoId = response.data.length > 0
        ? [(v: any) => this.validatePlano(v)]
        : []
    }

    if (formulario && formulario.categoria && formulario.categoria.habilitado) {
      this.getBackofficeGlobalStore.clearCategoria()
      this.getBackofficeGlobalStore.clearCategorias()
      if (hospital.hospitalFazConsultaCoberturaVigente && hospital.tipoDeCoberturaVigente === 'Categoria') {
        this.getBackofficeGlobalStore.setCategoriaCoberturaVigente(undefined)
      }
    }

    this.handleSurgerySolicitationEligibilityInfoFetch()

    this.loadingPlano = false
    this.loadingCategoria = false
  }

  async planoChange(planoId = '') {
    const { formulario } = this
    const { hospital, hospitalId, paciente } = this.getBackofficeGlobalStore.solicitacaoAlterada

    if (planoId && formulario && formulario.categoria && formulario.categoria.habilitado) {
      this.loadingCategoria = true
      this.getBackofficeGlobalStore.clearCategoria()
      this.getBackofficeGlobalStore.clearCategorias()
      this.$refs.solicitacaoAlteradaForm.resetValidation()
      const request = await this.getBackofficeGlobalStore.getAllCategoriasByPlano({ hospitalId, planoId, convenioId: paciente.convenioId })
      if (request.success) {
        this.solicitacaoAlteradaForm.categoriaId = request.data.length > 0
          ? [(v: any) => !!v || 'Campo obrigatório.']
          : []
      } else {
        this.getBackofficeGlobalStore.clearCategorias()
      }

      if (hospital.hospitalFazConsultaCoberturaVigente && hospital.tipoDeCoberturaVigente === 'Categoria') {
        this.getBackofficeGlobalStore.setCategoriaCoberturaVigente(undefined)
      }

      this.loadingCategoria = false
    }
  }

  setCarater(key: string) {
    switch (key) {
      case 'EletivoAutorizacao':
        return 'Eletivo'
      case 'Urgencia':
        return 'Urgência'
      default:
        return 'Emergência'
    }
  }

  setLateralidade(key: any) {
    switch (key) {
      case 'NaoAplica':
        return 'Não Aplica'
      case 'Direito':
        return 'Direito'
      case 'Esquerdo':
        return 'Esquerdo'
      case 'Bilateral':
        return 'Bilateral'
      default:
        return 'Não Aplica'
    }
  }

  possuiOMesmoFornecedor(id1: string | undefined, id2: string | undefined, id3: string | undefined) {
    id1 = id1 || 'id1'
    id2 = id2 || 'id2'
    id3 = id3 || 'id3'

    if (
      id1 === id2
      || id1 === id3
      || id2 === id3
    ) {
      return true
    }

    return false
  }

  possuiFornecedoresDuplicados() {
    const { grupoDeOpme } = this.getBackofficeGlobalStore.solicitacaoAlterada
    if (!grupoDeOpme || !grupoDeOpme.opmes) return false

    const exists = !grupoDeOpme.opmes.every((opme: any) => {
      const { fornecedor1Id, fornecedor2Id, fornecedor3Id } = opme
      return !this.possuiOMesmoFornecedor(fornecedor1Id, fornecedor2Id, fornecedor3Id)
    })

    if (exists) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Existem materiais com fornecedores duplicados, revise a lista de materiais.', icon: 'warning', color: '#C62828', timeout: 5500 })
    }

    return exists
  }

  isGreaterThanZero(v: any) {
    const num: any = parseInt(v, 10)
    return Number.isNaN(num) || num < 1 ? 'Campo obrigatório.' : false
  }

  reservaUTIWarning: string = ''
  reservaUTIDisabled: boolean = false

  validarDiariaHospital(e: string | null) {
    const { diaria } = this.formulario
    this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diaria', value: null })
    if (diaria && diaria.obrigatorio) {
      this.solicitacaoAlteradaForm.diaria = e === 'Internacao'
        ? [(v: any) => this.isGreaterThanZero(v)]
        : []
      if (e === 'Ambulatorial') this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diaria', value: null })
      if (e === 'HospitalDia') this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diaria', value: null })
    } else if (e === 'HospitalDia') {
      this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diaria', value: null })
    }

    if (diaria && !diaria.obrigatorio && e === 'Ambulatorial') {
      this.solicitacaoAlteradaForm.diaria = []
      this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diaria', value: null })
    }

    if (!diaria && e === 'Ambulatorial') {
      this.solicitacaoAlteradaForm.diaria = []
      this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diaria', value: null })
    }

    if (this.opcaoHabilitado('formularioMedico', 'limparReservaUtiNoTipoDeInternacaoAmbulatorial')) {
      if (e === 'Ambulatorial' && this.opcaoHabilitado('reservaUti', 'semReservaUti')) {
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'reservaUTI', value: 'SemReserva' })
        this.reservaUTIWarning = 'Quando o tipo de procedimento é ambulatorial, a reserva de UTI fica suspensa.'
        this.reservaUTIDisabled = true
        if (this.campoHabilitado('diariUti')) this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diariaUti', value: 0 })
      } else {
        this.reservaUTIWarning = ''
        this.reservaUTIDisabled = false
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'reservaUTI', value: 0 })
        this.$refs.reservaUTI.resetValidation()
      }
    }

    this.handleSurgerySolicitationEligibilityInfoFetch()
  }

  validarDiariaUti(e: any) {
    const { diariaUti } = this.formulario
    if (diariaUti && diariaUti.obrigatorio) {
      this.solicitacaoAlteradaForm.diariaUti = ['SemReserva', 'ReservaUtiNao'].includes(e)
        ? []
        : [(v: any) => this.isGreaterThanZero(v)]
    }
    if (['SemReserva', 'ReservaUtiNao'].includes(e)) this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'diariaUti', value: null })
  }

  get tipoAcomodacaoHis() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada
      && this.getBackofficeGlobalStore.solicitacaoAlterada.hospital
      && !!this.getBackofficeGlobalStore.solicitacaoAlterada.hospital.utilizaTipoAcomodacaoHospital
  }

  async alterarSolicitacao() {
    if (this.possuiFornecedoresDuplicados()) {
      return
    }

    this.loadingAlterar = true

    if (this.$refs.honorarioAnestesista && !this.$refs.honorarioAnestesista.$refs.honorarioAnestesista.validate()) {
      this.loadingAlterar = false
      return
    }

    if (this.$refs.honorarioMedico && !this.$refs.honorarioMedico.$refs.honorarioMedico.validate()) {
      this.loadingAlterar = false
      return
    }

    if (this.$refs.hemocomponentes && !this.$refs.hemocomponentes.$refs.reservaHemocomponentes.validate()) {
      this.loadingAlterar = false
      return
    }

    this.$refs.solicitacaoAlteradaForm.validate()
    const solicitacaoAlteradaFormErrors = await this.$refs.solicitacaoAlteradaForm.errorBag

    let counterValid = Object.values(solicitacaoAlteradaFormErrors).filter(e => e === true).length

    // O formulário de OPME só é renderizado quando a edição de materiais está habilitada
    // no template do hospital (opção `naoEditarOpme`), então o ref pode não existir.
    const { opmeForm } = this.$refs
    if (opmeForm) {
      opmeForm.validate()
      const errorsOpmeForm = await opmeForm.errorBag
      counterValid += Object.values(errorsOpmeForm).filter(e => e === true).length
    }

    if (!this.validateProcedimentoPrincipalErrorMessage()) {
      counterValid += 1
    }

    if (counterValid < 1) {
      if (this.hospital.usaProcedimentosApenasHospitalDia && this.opcaoHabilitado('tipoProcedimento', 'hospitalDia')) {
        await this.getBackofficeGlobalStore.getProcedimentosHospitalDiaByHospital()

        if (this.getBackofficeGlobalStore.todosProcedimentosHospitalDia) {
          const hospitalDiaExpected: boolean = this.getBackofficeGlobalStore.solicitacaoAlterada.tipoProcedimento === 'HospitalDia'
          const diariaExpected: boolean = this.campoHabilitado('diaria') && this.getBackofficeGlobalStore.solicitacaoAlterada.diaria === 1
          const reservaUtiExpected: boolean = (this.opcaoHabilitado('reservaUti', 'reservaUtiNao') || this.opcaoHabilitado('reservaUti', 'semReservaUti')) && ['SemReserva', 'ReservaUtiNao'].includes(this.getBackofficeGlobalStore.solicitacaoAlterada.reservaUTI)

          if (!hospitalDiaExpected || !diariaExpected || !reservaUtiExpected) {
            this.getSolicitacaoCirurgiaStore.setModal({ name: 'procedimentosApenasHospitalDiaWarning', value: true })
            this.loadingAlterar = false
            return
          }
        }
      }

      if (this.opcaoHabilitado('anestesiaHospital', 'anestesistaLista')) {
        if (this.hospitalAnesthetist.id) {
          this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
            field: 'anestesistaId',
            value: this.hospitalAnesthetist.id,
          })
        } else {
          this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
            field: 'anestesistaId',
            value: '',
          })
        }
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
          field: 'anestesista',
          value: '',
        })
      }
      if (this.getBackofficeGlobalStore.solicitacaoAlterada.anestesiaDoHospital === 'Sim' && !this.opcaoHabilitado('anestesiaHospital', 'anestesistaLista')) {
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
          field: 'nomeAnestesista',
          value: '',
        })
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
          field: 'anestesistaCrm',
          value: '',
        })
      }

      if (this.campoHabilitado('anestesiaHospital') && this.opcaoHabilitado('anestesiaHospital', 'hospitalUtilizaClinicasDeAnestesia')) {
        if (this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista === 'Outros') {
          this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
            field: 'anestesiaDoHospital',
            value: '',
          })
          this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
            field: 'anestesistaId',
            value: '',
          })
          this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
            field: 'nomeAnestesista',
            value: this.outroAnestesista,
          })
        } else {
          this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
            field: 'nomeAnestesista',
            value: '',
          })
          if (this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista && typeof this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista === 'object') {
            this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
              field: 'anestesistaId',
              value: this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.id,
            })
            this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
              field: 'anestesista',
              value: '',
            })
          }
        }
      }

      const response = await this.getBackofficeGlobalStore.backofficeAgendamentoAtualizaSolicitacao()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação alterada com sucesso!', icon: 'done', color: '#2E7D32', timeout: 4000 })
        await this.store.loadAgendamentosMedicoSearch()
        await this.closeModal()
      } else {
        const errorMessage = this.formatarMensagemErro(response)
        EventBus.$emit('setSnackbar', { show: true, text: errorMessage, icon: 'warning', color: '#C62828', timeout: 7500, acceptHTML: true })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counterValid} erro(s) no formulário.`, icon: 'warning', color: '#C62828' })
    }

    this.loadingAlterar = false
  }

  async alterarOrcamento() {
    if (this.possuiFornecedoresDuplicados()) {
      return
    }

    this.loadingAlterar = true

    if (this.$refs.honorarioAnestesista && !this.$refs.honorarioAnestesista.$refs.honorarioAnestesista.validate()) {
      this.loadingAlterar = false
      return
    }

    if (this.$refs.honorarioMedico && !this.$refs.honorarioMedico.$refs.honorarioMedico.validate()) {
      this.loadingAlterar = false
      return
    }

    if (this.$refs.hemocomponentes && !this.$refs.hemocomponentes.$refs.reservaHemocomponentes.validate()) {
      this.loadingAlterar = false
      return
    }

    this.$refs.solicitacaoAlteradaForm.validate()
    const solicitacaoAlteradaFormErrors = await this.$refs.solicitacaoAlteradaForm.errorBag

    let counterValid = Object.values(solicitacaoAlteradaFormErrors).filter(e => e === true).length

    // O formulário de OPME só é renderizado quando a edição de materiais está habilitada
    // no template do hospital (opção `naoEditarOpme`), então o ref pode não existir.
    const { opmeForm } = this.$refs
    if (opmeForm) {
      opmeForm.validate()
      const errorsOpmeForm = await opmeForm.errorBag
      counterValid += Object.values(errorsOpmeForm).filter(e => e === true).length
    }

    if (!this.validateProcedimentoPrincipalErrorMessage()) {
      counterValid += 1
    }

    if (counterValid >= 1) {
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counterValid} erro(s) no formulário.`, icon: 'warning', color: '#C62828' })
      this.loadingAlterar = false
      return
    }

    const [isValid, errorMessage] = this.validateExamesIntraoperatorios()

    if (!isValid) {
      EventBus.$emit('setSnackbar', { show: true, text: errorMessage, icon: 'warning', color: '#C62828' })
      this.loadingAlterar = false
      return
    }

    if (this.hospital.usaProcedimentosApenasHospitalDia && this.opcaoHabilitado('tipoProcedimento', 'hospitalDia')) {
      await this.getBackofficeGlobalStore.getProcedimentosHospitalDiaByHospital()

      if (this.getBackofficeGlobalStore.todosProcedimentosHospitalDia) {
        const hospitalDiaExpected: boolean = this.getBackofficeGlobalStore.solicitacaoAlterada.tipoProcedimento === 'HospitalDia'
        const diariaExpected: boolean = this.campoHabilitado('diaria') && this.getBackofficeGlobalStore.solicitacaoAlterada.diaria === 1
        const reservaUtiExpected: boolean = (this.opcaoHabilitado('reservaUti', 'reservaUtiNao') || this.opcaoHabilitado('reservaUti', 'semReservaUti')) && ['SemReserva', 'ReservaUtiNao'].includes(this.getBackofficeGlobalStore.solicitacaoAlterada.reservaUTI)

        if (!hospitalDiaExpected || !diariaExpected || !reservaUtiExpected) {
          this.getSolicitacaoCirurgiaStore.setModal({ name: 'procedimentosApenasHospitalDiaWarning', value: true })
          this.loadingAlterar = false
          return
        }
      }
    }

    if (this.getBackofficeGlobalStore.solicitacaoAlterada.anestesiaDoHospital === 'Nao') {
      this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
        field: 'anestesistaId',
        value: this.hospitalAnesthetist.id,
      })
    }

    this.modalManager.openModal(this.viewModal.confirmarFluxoAlteracaoOrcamento)
    this.loadingAlterar = false
  }

  handleAlterar() {
    const alteracao = this.getBackofficeGlobalStore.solicitacaoAlterada.etapa.key === 'Orcamento'
      ? this.alterarOrcamento()
      : this.alterarSolicitacao()

    // Sem esse catch, qualquer exceção inesperada deixa o botão travado em loading
    // e sem nenhum retorno para o usuário (a promise rejeitada só aparece no console).
    alteracao.catch((error: any) => {
      console.error(error)
      this.loadingAlterar = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao processar a requisição.', icon: 'warning', color: '#C62828' })
    })
  }

  formatarMensagemErro(response: any): string {
    let mensagem = response.message || 'Houve um erro ao processar a requisição.'

    if (response.errors && Array.isArray(response.errors) && response.errors.length > 0) {
      const errosFormatados: string[] = []

      response.errors.forEach((erro: any) => {
        if (typeof erro === 'object' && erro.message) {
          errosFormatados.push(erro.message)
        } else if (typeof erro === 'string') {
          errosFormatados.push(erro)
        }
      })

      if (errosFormatados.length > 0) {
        mensagem = `${mensagem}<br><br>${errosFormatados.map(e => `• ${e}`).join('<br>')}`
      }
    }

    mensagem = mensagem.replace(/\n/g, '<br>')

    return mensagem
  }


  async fechar(botao: string) {
    const btn: string = botao.toUpperCase() === 'CANCELAR' ? 'loadingCancelar' : 'loadingFechar'
    this[btn] = true
    await timeout(500)
    await this.closeModal()
    this.showModalAlterarSolicitacao = false
    this.loadingAlterar = false
    this[btn] = false
  }

  async closeModal() {
    await this[this.implemantation].desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacaoAlterada.solicitacaoId)
    this.$refs.solicitacaoAlteradaForm.reset()
    this.getBackofficeGlobalStore.clearSolicitacaoAlterada()
    this.getBackofficeGlobalStore.clearGrupoOpmeDaSolicitacao()
    this.getBackofficeGlobalStore.clearTipoAcomodacaoItems()
    this.$refs.solicitacaoAlteradaForm.resetValidation()
    if (this.$refs.honorarioMedico) this.$refs.honorarioMedico.$refs.honorarioMedico.resetValidation()
    if (this.$refs.honorarioAnestesista) this.$refs.honorarioAnestesista.$refs.honorarioAnestesista.resetValidation()
    this.outroAnestesista = ''
    this.getBackofficeGlobalStore.setModal({ name: 'alterarSolicitacao', value: false })
    if (this.$refs.hemocomponentes) {
      this.$refs.hemocomponentes.$refs.reservaHemocomponentes.resetValidation()
      this.$refs.hemocomponentes.$refs.reservaHemocomponentes.reset()
    }
    this.lastSelectedEquipmentsBeforeHospitalChange = []
    this.getBackofficeGlobalStore.clearTemplate()
    this.backofficeSharedDataService.reset()
  }

  get implemantation() {
    switch (this.$route.name) {
      case 'BackofficeAgendamento':
        return 'agd'
      case 'BackofficeAutorizacao':
        return 'aut'
      default:
        return 'agd'
    }
  }

  get store() {
    return this.implemantation === 'agd' ? this.getBackofficeAgendamentoStore : this.getBackofficeAutorizacaoStore
  }

  async fetchMedicosExecutantes() {
    await useMedicos.loadMedicosHospitaisPorUsuarioAtual({
      params: {
        usuarioId: this.$user.profile.sub,
        hospitalId: this.hospital.id,
      },
    })
  }

  get doctors() {
    return useMedicos.medicosByCurrentUser
  }

  get doctorsSurgeryTeam() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.equipeCirurgica
  }

  set doctorsSurgeryTeam(doctorData) {
    this.getBackofficeGlobalStore.solicitacaoAlterada.equipeCirurgica = doctorData
  }

  addDoctorToSurgeryTeam() {
    this.doctorsSurgeryTeam!.push({ conselhoTipo: '', conselhoUf: '', conselhoNumero: '', medicoNome: '' })
  }

  @Watch('showModalAlterarSolicitacao')
  onChangeShowModalAlterarSolicitacao(value: boolean) {
    if (value) {
      this.$refs.solicitacaoAlteradaForm.resetValidation()
      this.setAnesthetist()

      if (this.campoObrigatorio('idadeGestacional') && this.habilitaCamposGestacionais()) {
        this.solicitacaoAlteradaForm.idadeGestacional.push(v => !['', null, undefined].includes(v) || 'Campo obrigatório.')
      }

      if (this.campoObrigatorio('gemelar') && this.habilitaCamposGestacionais()) {
        this.solicitacaoAlteradaForm.gemelar.push(v => typeof v === 'boolean' || 'Campo obrigatório.')
      }

      this.solicitacaoAlteradaForm.classificacaoPacienteOncologico = []
      if (this.campoObrigatorio('classificacaoPacienteOncologico')) {
        this.solicitacaoAlteradaForm.classificacaoPacienteOncologico.push(v => typeof v === 'boolean' || 'Campo obrigatório.')
      }
      if (this.campoHabilitado('instrumentadorExterno')) {
        this.solicitacaoAlteradaForm.instrumentadorExternoEspecificar.push(v => this.validateInstrumentadorExterno(v))
      }

      if (this.opcaoHabilitado('formularioMedico', 'limparReservaUtiNoTipoDeInternacaoAmbulatorial')) {
        if (this.getBackofficeGlobalStore.solicitacaoAlterada.tipoProcedimento === 'Ambulatorial' && this.opcaoHabilitado('reservaUti', 'semReservaUti')) {
          this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'reservaUTI', value: 'SemReserva' })
          this.reservaUTIWarning = 'Quando o tipo de procedimento é ambulatorial, a reserva de UTI fica suspensa.'
          this.reservaUTIDisabled = true
        }
      }

      if (
        this.getBackofficeGlobalStore.solicitacaoAlterada.tipoProcedimento === 'Internacao'
        && this.campoHabilitado('diaria') && this.template.formulario.diaria.obrigatorio
      ) {
        this.solicitacaoAlteradaForm.diaria.push((v: any) => this.isGreaterThanZero(v))
      }

      if (
        !['ReservaUtiNao', 'SemReserva'].includes(this.getBackofficeGlobalStore.solicitacaoAlterada.reservaUTI)
        && this.campoHabilitado('diariaUti') && this.template.formulario.diariaUti.obrigatorio
      ) {
        this.solicitacaoAlteradaForm.diariaUti.push((v: any) => this.isGreaterThanZero(v))
      }

      if (this.campoHabilitado('equipeMedica')
        && this.opcaoHabilitado('equipeMedica', 'dadosDoConselho')
        && this.getBackofficeGlobalStore.solicitacaoAlterada.temEquipeMedica) {
        if (!this.doctorsSurgeryTeam || this.doctorsSurgeryTeam.length === 0) {
          this.addDoctorToSurgeryTeam()
        }
      }
      if (this.campoHabilitado('medicoExecutante')) {
        this.fetchMedicosExecutantes()
      }
    }
  }

  get temNaoInformadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacaoAlterada
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoInformado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoInformado.push(false)
        if (!opme.fornecedor2) algumNaoInformado.push(false)
        if (!opme.fornecedor3) algumNaoInformado.push(false)

        // Caso não exista a flag de alertaFornecedorNaoInformado, utilizar o método antigo
        const invalido = (f: string) => {
          const e = f
          return opme[e] === undefined
            ? false
            : opme[e].nome.toUpperCase() === 'NÃO INFORMADO' || !!opme[e].alertaFornecedorNaoInformado
        }

        algumNaoInformado.push(invalido('fornecedor1'))
        algumNaoInformado.push(invalido('fornecedor2'))
        algumNaoInformado.push(invalido('fornecedor3'))
      })
    })
    return algumNaoInformado.some((e: boolean) => e)
  }

  get temNaoHomologadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacaoAlterada
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoHomologado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoHomologado.push(false)
        if (!opme.fornecedor2) algumNaoHomologado.push(false)
        if (!opme.fornecedor3) algumNaoHomologado.push(false)

        algumNaoHomologado.push(!!opme.fornecedor1 && !!opme.fornecedor1.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor2 && !!opme.fornecedor2.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor3 && !!opme.fornecedor3.alertaFornecedorNaoHomologado)
      })
    })
    return algumNaoHomologado.some((e: boolean) => e)
  }

  get temFornecedorSemHisId() {
    const solicitacao = this.getBackofficeGlobalStore && this.getBackofficeGlobalStore.solicitacaoAlterada

    if (
      !solicitacao
      || !solicitacao.hospital
      || !solicitacao.hospital.hospitalValidaHisIdDoFornecedorOpme
    ) {
      return false
    }

    const grupos = solicitacao.grupoOpmeDaSolicitacao
    if (!grupos || !grupos.length) {
      return false
    }

    return grupos.some((grupo: any) => {
      if (!grupo.opmes) return false

      return grupo.opmes.some((opme: any) => {
        const fornecedores = [opme.fornecedor1, opme.fornecedor2, opme.fornecedor3]
        return fornecedores.some((f: any) => f && f.alertaDeFornecedorSemHisId)
      })
    })
  }

  async openModalEditarFornecedorOPME(flag: string) {
    this.loadingEditarFornecedores = flag
    const request = await this.getBackofficeGlobalStore.getFornecedoresFromApi('solicitacaoAlterada')
    if (request && request.length > 0) {
      this.getBackofficeGlobalStore.setModal({ name: 'modalEditarFornecedorOPME', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || `Ocorreu um erro ao buscar fornecedores... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingEditarFornecedores = ''
  }

  async showModalEquipamento() {
    this.loadingEquipamento = true
    await this.getBackofficeGlobalStore.getAlterarSolicitacaoEquipamentoGruposApiSearch('')
    this.getBackofficeGlobalStore.setModal({ name: 'editarEquipamento', value: true })
    this.loadingEquipamento = false
  }

  /** Instrumentador externo */
  validateInstrumentadorExterno(value: any) {
    if (['', null, undefined].includes(value) || !String(value).trim()) return 'Campo obrigatório.'
    return false
  }

  instrumentadorExternoChange(instrumentadorExterno: boolean) {
    if (instrumentadorExterno) {
      this.solicitacaoAlteradaForm.instrumentadorExternoEspecificar.push(v => this.validateInstrumentadorExterno(v))
    } else {
      this.solicitacaoAlteradaForm.instrumentadorExternoEspecificar.splice(0, this.solicitacaoAlteradaForm.instrumentadorExternoEspecificar.length)
      this.getBackofficeGlobalStore.clearSolicitacaoAlteradaInstrumentadorExternoEspecificar()
    }
  }

  // Permissions

  get canShowLastSelectedEquipmentsBeforeHospitalChange() {
    return this.lastSelectedEquipmentsBeforeHospitalChange.length > 0
  }

  canEditProcedimentoPrincipal() {
    return !this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      || (this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      && this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo)
  }

  canAddOrDeleteProcedimentoAssociado() {
    return !this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      || (this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      && this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo)
  }

  canAddOrDeleteOpme() {
    return !this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      || (this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      && this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo)
  }

  canEditNumeroLeito() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.acoes.permiteEditarLeitoDoPaciente
  }

  canEditNumeroAtendimento() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.acoes.permiteEditarNumeroDoAtendimentoAoPacienteNoHospital
  }

  canEditMedicoExecutante() {
    return !!this.getBackofficeGlobalStore.solicitacaoAlterada.acoes.alterarMedicoSolicitante
  }

  onChangeClinicaAnestesista(value: string) {
    this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
      field: 'anestesista',
      value,
    })
    if (value !== 'Outros') {
      this.outroAnestesista = ''
      this.$forceUpdate()
      return
    }
    this.outroAnestesista = this.getBackofficeGlobalStore.solicitacaoAlterada.nomeAnestesista || ''
    this.$forceUpdate()
  }

  async handleConfirmar(acaoDoUsuario: string) {
    this.modalManager.closeModal(this.viewModal.confirmarFluxoAlteracaoOrcamento)

    this.loadingAlterar = true
    const { success } = await this.getBackofficeGlobalStore.atualizarOrcamento(acaoDoUsuario)
    this.loadingAlterar = false

    if (!success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro ao atualizar o orcamento.',
        icon: 'error',
        color: '#C62828',
      })
      return
    }

    await this.getBackofficeOrcamentoStore.loadAgendamentosMedicoSearch()

    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'O orçamento foi atualizado.',
      color: '#60b084',
    })

    this.closeModal()
  }

  get getOutrosTipoAnestesia(): string {
    const outros = (this.getBackofficeGlobalStore.solicitacaoAlterada.tipoAnestesia || [])
      .find((item: { tipo: { key: string, display: string}, outrosTipoAnestesia?: string }) => item.tipo.key === 'Outros')
    return outros ? outros.outrosTipoAnestesia || '' : ''
  }

  set getOutrosTipoAnestesia(valor: string) {
    this.getBackofficeGlobalStore.solicitacaoAlterada.tipoAnestesia = (this.getBackofficeGlobalStore.solicitacaoAlterada.tipoAnestesia || [])
      .map((item: { tipo: { key: string, display: string}, outrosTipoAnestesia?: string }) => {
        if (item.tipo.key === 'Outros') {
          return { outrosTipoAnestesia: valor, tipo: { key: 'Outros', display: 'Outros' } }
        }
        return item
      })
  }

  get getTipoAnestesia(): string[] {
    return (this.getBackofficeGlobalStore.solicitacaoAlterada.tipoAnestesia || [])
      .map((item: { tipo: { key: string, display: string} }) => item.tipo.key)
  }

  set getTipoAnestesia(novoValor: string[]) {
    const tipoAnestesia = this.getBackofficeGlobalStore.solicitacaoAlterada.tipoAnestesia || []
    this.getBackofficeGlobalStore.solicitacaoAlterada.tipoAnestesia = (novoValor || [])
      .map((key: string) => {
        const existente = tipoAnestesia.find((item: { tipo: { key: string } }) => item.tipo.key === key)
        return existente || { tipo: { key, display: key } }
      })
  }

  tipoAnestesiaChange(value: string) {
    if (!this.formulario.tipoAnestesia.multiSelecao) {
      this.getTipoAnestesia = [value]
    }
  }

  medicamentosEspeciaisChange(medicamentosEspeciais: boolean) {
    if (medicamentosEspeciais) {
      this.solicitacaoAlteradaForm.medicamentosEspeciaisEspecificar.push(value => !!value || 'Campo obrigatório.')
      return
    }
    this.solicitacaoAlteradaForm.medicamentosEspeciaisEspecificar = []
    this.getBackofficeGlobalStore.solicitacaoAlterada.medicamentosEspeciais = ''
  }

  handleVoltar() {
    this.modalManager.closeModal(this.viewModal.confirmarFluxoAlteracaoOrcamento)
    this.loadingAlterar = false
  }

  mounted() {
    EventBus.$on('refreshSolicitacaoAlterada', (value: boolean) => this.$forceUpdate())
    EventBus.$on('alterarSolicitacao', this.alterarSolicitacao)
    this.$forceUpdate()
  }
}
